// pipe.module.ts
import { NgModule } from '@angular/core';
import { CapitalizePipe } from './capitalize.pipe';
import { ChunkPipe } from './chunk.pipe';
import { CustomDatePipe } from './custom-date-time-pipe';
import { NaIfNullPipe } from './naIfNull.pipe';
import { UserImagePipe } from './userImage.pipe';
import { DefaultImagePipe } from './defaultImage.pipe';
import { FilterByDateGroupPipe } from './filterByDateGroup';
import { DateFormatPipe } from './dateFormatPipe';
import {HtmlDecodePipe} from './htmlDecode-pipe'


@NgModule({
  declarations: [
    CapitalizePipe,
    ChunkPipe,
    NaIfNullPipe,
    UserImagePipe,
    DefaultImagePipe,
    FilterByDateGroupPipe,
    DateFormatPipe,
    CustomDatePipe,
    HtmlDecodePipe
  ],
  exports: [
    CapitalizePipe,
    ChunkPipe,
    NaIfNullPipe,
    UserImagePipe,
    DefaultImagePipe,
    FilterByDateGroupPipe,
    DateFormatPipe,
    CustomDatePipe,
    HtmlDecodePipe
  ]
})
export class PipeModule { }
